module.exports = __webpack_public_path__ + "static/img/product3-3.dfbdb33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-3.jpg
// module id = Sd3d
// module chunks = 0